import { Button, Input, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import walkersService from "../../../../services/walkers.service";

const TmsSmWalkerPass = ({ router }) => {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);

  const getAllTags = async (page, size) => {
    setLoading(true);
    try {
      const data = await walkersService.getWalkersTagSerialAll(page, size);
      setTableData(
        data?.serials?.map((item) => ({
          key: item.id,
          ...item,
        }))
      );
      setTotal(data?.total || 0);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllTags(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleSubmit = async () => {
    // Basic validation
    if (!from || !to) {
      message.error("Please fill in both Serial Number From and To fields");
      return;
    }

    setSubmitLoading(true);
    try {
      const body = {
        serialNoFrom: from,
        serialNoTo: to,
      };

      await walkersService.createWalkersTagSerial(body);
      message.success("Walker tag serials created successfully");

      // Reset form
      setFrom("");
      setTo("");

      // Refresh table data
      await getAllTags(1, pageSize);
      setCurrentPage(1);
    } catch (error) {
      catchErrorFunction(error, "Failed to create walker tag serials", router);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    setFrom("");
    setTo("");
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Serial No. From",
      dataIndex: "serialNoFrom",
      key: "serialNoFrom",
      sorter: (a, b) => a.serialNoFrom.localeCompare(b.serialNoFrom),
    },
    {
      title: "Serial No. To",
      dataIndex: "serialNoTo",
      key: "serialNoTo",
      sorter: (a, b) => a.serialNoTo.localeCompare(b.serialNoTo),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => new Date(text).toLocaleString(),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
      }}
    >
      <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
        Assign Walkers Tag Upload Serial Number
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Serial Number From</label>
          <Input
            placeholder="Serial Number From"
            onChange={(e) => setFrom(e.target.value)}
            value={from}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Serial Number To</label>
          <Input
            placeholder="Serial Number To"
            onChange={(e) => setTo(e.target.value)}
            value={to}
          />
        </div>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button type="primary" onClick={handleSubmit} loading={submitLoading}>
          Submit
        </Button>
      </div>
      <br />
      <Table
        style={{ width: "100%" }}
        dataSource={tableData}
        columns={columns}
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default TmsSmWalkerPass;
